export default __webpack_public_path__ + "static/media/ldo_FIX_nEN.2ace5108.svg";